// Pelaaja-avaimet. Palvelin antaa jokaiselle pelaajalle oman avaimen, kun pelaaja luodaan tai lunastetaan, ja sovellus
// tallentaa ja lähettää sen itse: käyttäjä ei näe eikä kirjoita sitä. Avain estää toimimasta toisen pelaajan puolesta.
// Jos avain katoaa (uudelleenasennus), puhelin hakee uuden puhelimen tunnisteen avulla (api.js: recoverKey).

import { storage } from "./storage.js";

const KEY = "playerKeys";

/** Kaikki tallennetut avaimet muodossa { pelaajaTunnus: avain }. */
export function allPlayerKeys(store = storage) {
  const keys = store.get(KEY, {});
  return keys && typeof keys === "object" && !Array.isArray(keys) ? keys : {};
}

export function playerKey(id, store = storage) {
  const key = allPlayerKeys(store)[id];
  return typeof key === "string" && key ? key : "";
}

export function rememberPlayerKey(id, token, store = storage) {
  if (!id || typeof token !== "string" || !token) return;
  store.set(KEY, { ...allPlayerKeys(store), [id]: token });
}

/** Poistetun pelaajan avain ei jää muistiin. */
export function forgetPlayerKey(id, store = storage) {
  const keys = { ...allPlayerKeys(store) };
  delete keys[id];
  store.set(KEY, keys);
}
